module.exports = __webpack_public_path__ + "img/settings.539fbdee.svg";